import { Container, styled } from '@mui/material';
import HeaderLayout from '../../../components/Layout/Header/HeaderLayout';
import BodyTransactionsWallet from '../../../components/wallet/BodyTransactionsWallet';
import { useCashBalance } from '../../../context/CashBalanceContext';
import { useGetClientTransactionsWallet } from '../../../hooks/useGetClientTransactionsWallet';

const StyledContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: '60px',
  backgroundColor: theme.palette.white.main,
}));

const currencyFormatter = new Intl.NumberFormat('es-CL', {
  style: 'currency',
  currency: 'CLP',
});

const clpPrice = {
  type: 'number',
  width: 130,
  valueFormatter: ({ value }) => currencyFormatter.format(value),
  cellClassName: 'font-tabular-nums',
};
const column = [
  {
    field: 'fecha',
    headerName: 'Fecha',
    width: 120,
    flex: '0.5 1 120px',
    hide: true,
  },
  {
    field: 'movimiento',
    headerName: 'Movimientos',
    flex: '0.6 2 80px',
    width: 160,
    cellClassName: 'super-app-theme--cell',
  },
  {
    field: 'monto',
    ...clpPrice,
    headerName: 'Monto',
    flex: '0.5 1 60',
    width: 120,
  },
];

const Wallet = () => {
  const {
    data: transactionsData,
    loading: loadingTransactions,
    error: errorTransactions,
    refetch: refetchTransactions,
  } = useGetClientTransactionsWallet();

  const transactions = transactionsData?.getClientTransactions;

  const {
    balance: balanceData,
    loading: loadingBalance,
    error: errorBalance,
    refetch: refetchBalance,
  } = useCashBalance();

  const fileAs = {
    currency: 'pesos',
    fileAs: 'file as',
    fileAsComplete: 'file as complete',
    risk: 'agresivo',
    profit: '10',
  };
  return (
    <>
      <HeaderLayout fileAs={fileAs} />

      <StyledContainer maxWidth='1380px'>
        <BodyTransactionsWallet
          column={column}
          isWallet={true}
          titleText={'Transacciones'}
          balanceData={balanceData}
          loadingBalance={loadingBalance}
          errorBalance={errorBalance}
          refetchBalance={refetchBalance}
          transactions={transactions}
          loadingTransactions={loadingTransactions}
          errorTransactions={errorTransactions}
          refetchTransactions={refetchTransactions}
        />
      </StyledContainer>
    </>
  );
};

export default Wallet;
